export const dragConstants = {
  SET_DRAG_OVER_TARGET: 'SET_DRAG_OVER_TARGET',
}
